import { useContext, useEffect, useState } from "react";
import { DatePicker } from "zaman";
import axios from 'axios';

import { Container, Form, Row, Col, Button } from "react-bootstrap";
import Banks from '../../utils/banks.json';
import Province from '../../utils/province.json';
import City from '../../utils/city.json';
import { MyContext } from "../helper/MyContext";

const FormData = require('form-data');

export default function StepOne(props) {
    const url = 'https://khpc.ir/sup-upload/';
    const [firstData, setFirstData] = useState(true);
    const [type, setType] = useState("1");
    const [builder, setBuilder] = useState(false);
    const [commerce, setCommerce] = useState(false);
    const [service, setService] = useState(false);
    const [contractor, setContractor] = useState(props.isContractor);
    const [store, setStore] = useState('');
    const [oldStore, setOldStore] = useState('');
    const [businessLicense, setBusinessLicense] = useState('');
    const [establishmentStore, setEstablishmentStore] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [economicCode, setEconomicCode] = useState('');
    ///
    const [province, setProvince] = useState('');
    const [city, setCity] = useState('');
    const [postalcode, setPostalCode] = useState('');
    const [postBox, setPostBox] = useState('');
    const [address, setAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [phoneTwo, setPhoneTwo] = useState('');
    const [phoneThree, setphoneThree] = useState('');
    const [cellPhone, setCellPhone] = useState('');
    const [fax, setFax] = useState('');
    const [email, setEmail] = useState('');
    const [website, setWebsite] = useState('');
    const [cityCode, setCityCode] = useState('');
    ///
    const [bank, setBank] = useState('');
    const [branch, setBranch] = useState('');
    const [shaba, setShaba] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [ownerName, setOwnerName] = useState('');
    ///
    const [bankTwo, setBankTwo] = useState('');
    const [branchTwo, setBranchTwo] = useState('');
    const [shabaTwo, setShabaTwo] = useState('');
    const [accountNumberTwo, setAccountNumberTwo] = useState('');
    const [ownerNameTwo, setOwnerNameTwo] = useState('');
    ///
    const [ownership, setOwnership] = useState(1);
    const [otherOwnerShip, setOtherOwnerShip] = useState('');
    const [formCompletion, setFormCompletion] = useState('');

    ///


    const [companyName, setCompanyName] = useState('');
    const [oldCompanyName, setOldCompanyName] = useState('');
    const [registerCodeCompany, setRegisterCodeCompany] = useState('');
    const [registerDateCompany, setRegisterDateCompany] = useState('');
    const [idInternationalCode, setIdInternationalCode] = useState('');
    const [economicCodeCompany, setEconomicCodeCompany] = useState('');
    const [companyCapital, setCompanyCapital] = useState('');
    const [managerName, setManagerName] = useState('');

    ///

    const [typeCompany, setTypeCompany] = useState(1);
    const [otherTypeCompany, setOtherTypeCompany] = useState('');

    const [submit, setSubmit] = useState(false);

    const { user } = useContext(MyContext);


    useEffect(() => {
        let Mount = true;
        if (Mount) {
            let data = new FormData();
            data.append('userId', user);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://khpc.ir/api-supplier/api/getRequestByUserId',
                data: data
            };

            axios.request(config)
                .then((response) => {
                    var data = JSON.parse(response.data.data.dataOne);
                    console.log(data)
                    if (data) {
                        props.handleContractor(data.contractor)
                        setType(data.type);
                        setAccountNumber(data.accountNumber);
                        setAccountNumberTwo(data.accountNumberTwo);
                        setAddress(data.address);
                        setBank(data.bank);
                        setBankTwo(data.bankTwo);
                        setBranch(data.branch);
                        setBranchTwo(data.branchTwo);
                        setBuilder(data.builder);
                        setBusinessLicense(data.businessLicense);
                        setCellPhone(data.cellPhone);
                        setCity(data.city);
                        setCityCode(data.cityCode);
                        setCommerce(data.commerce);
                        setCompanyCapital(data.companyCapital);
                        setCompanyName(data.companyName);
                        setContractor(data.contractor);
                        setEconomicCode(data.economicCode);
                        setEconomicCodeCompany(data.economicCodeCompany);
                        setEmail(data.email);
                        setEstablishmentStore(data.establishmentStore);
                        setFax(data.fax);
                        setFormCompletion(data.formCompletion);
                        setIdInternationalCode(data.idInternationalCode);
                        setManagerName(data.managerName);
                        setNationalCode(data.nationalCode);
                        setOldCompanyName(data.oldCompanyName);
                        setOldStore(data.oldStore);
                        setOtherOwnerShip(data.otherOwnerShip);
                        setOtherTypeCompany(data.otherTypeCompany);
                        setOwnerName(data.ownerName);
                        setOwnerNameTwo(data.ownerNameTwo);
                        if (data.ownership) {
                            setOwnership(data.ownership);
                        } else {
                            setOwnership(1);
                        }
                        setPhone(data.phone);
                        setphoneThree(data.phoneThree);
                        setPhoneTwo(data.phoneTwo);
                        setPostBox(data.postBox);
                        setPostalCode(data.postalcode);
                        setProvince(data.province);
                        setRegisterCodeCompany(data.registerCodeCompany);
                        setRegisterDateCompany(data.registerDateCompany);
                        setService(data.service);
                        setShaba(data.shaba);
                        setShabaTwo(data.shabaTwo);
                        setStore(data.store);
                        if (data.typeCompany) {
                            setTypeCompany(data.typeCompany);
                        } else {
                            setWebsite(1);
                        }
                    }

                    setFirstData(false)
                })
                .catch((error) => {
                    setFirstData(false)
                    // alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                });
        }
        return () => Mount = false;
    }, []);








    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const changeStep = () => {
        setSubmit(true);

        if (type == "1" && store == '' || type == "1" && businessLicense == '' || type == "1" && establishmentStore == '' || type == "1" && nationalCode == '' || type == "1" && province == '' || type == "1" && city == '' || type == "1" && postalcode == '' || type == "1" && address == '' || type == "1" && phone == '' || type == "1" && cityCode == '' || type == "1" && cellPhone == '' || type == "1" && email == '' || type == "1" && bank == '' ||
            type == "1" && branch == '' ||
            type == "1" && shaba == '' ||
            type == "1" && accountNumber == '' ||
            type == "1" && ownerName == '' ||
            (type == "1" && ownership == 6 &&
                otherOwnerShip == '') ||
            type == "1" && formCompletion == '') {
            alert('فیلدهای مشخص شده الزامی هستند');
            return;
        }

        if (type == "2" && companyName == '' ||
            type == "2" && registerCodeCompany == '' ||
            type == "2" && registerDateCompany == '' ||
            type == "2" && idInternationalCode == '' ||
            type == "2" && economicCodeCompany == '' ||
            type == "2" && companyCapital == '' || type == "2" && managerName == '' || type == "2" && province == '' || type == "2" && city == '' || type == "2" && postalcode == '' || type == "2" && address == '' || type == "2" && phone == '' || type == "2" && cityCode == '' || type == "2" && cellPhone == '' || type == "2" && email == '' || type == "2" && bank == '' ||
            type == "2" && branch == '' ||
            type == "2" && shaba == '' ||
            type == "2" && accountNumber == '' ||
            type == "2" && ownerName == '' ||
            (type == "2" && typeCompany == 5 &&
                otherTypeCompany == '') ||
            type == "2" && formCompletion == '') {
            alert('فیلدهای مشخص شده الزامی هستند');
            return;
        }

        if (!/^09\d{9}$/.test(cellPhone)) {
            alert('فرمت شماره موبایل نادرست است');
            return;
        }

        if (!validateEmail(email)) {
            alert('فرمت ایمیل نادرست است');
            return;
        }


        window.scrollTo(0, 0);
        var dataAdd = {
            type: type,
            builder: builder,
            commerce: commerce,
            service: service,
            contractor: contractor,
            store: store,
            oldStore: oldStore,
            businessLicense: businessLicense,
            establishmentStore: establishmentStore,
            nationalCode: nationalCode,
            economicCode: economicCode,
            ///
            companyName: companyName,
            oldCompanyName: oldCompanyName,
            registerCodeCompany: registerCodeCompany,
            registerDateCompany: registerDateCompany,
            idInternationalCode: idInternationalCode,
            economicCodeCompany: economicCodeCompany,
            companyCapital: companyCapital,
            managerName: managerName,
            typeCompany: typeCompany,
            otherTypeCompany: otherTypeCompany,
            ///
            province: province,
            city: city,
            postalcode: postalcode,
            postBox: postBox,
            address: address,
            phone: phone,
            phoneTwo: phoneTwo,
            phoneThree: phoneThree,
            cellPhone: cellPhone,
            fax: fax,
            email: email,
            website: website,
            cityCode: cityCode,
            bank: bank,
            branch: branch,
            shaba: shaba,
            accountNumber: accountNumber,
            ownerName: ownerName,
            bankTwo: bankTwo,
            branchTwo: branchTwo,
            shabaTwo: shabaTwo,
            accountNumberTwo: accountNumberTwo,
            ownerNameTwo: ownerNameTwo,
            ownership: ownership,
            otherOwnerShip: otherOwnerShip,
            formCompletion: formCompletion
        };

        let data = new FormData();
        data.append('userId', user);
        data.append('type', type);
        data.append('nationalCode', nationalCode);
        data.append('idInternationalCode', idInternationalCode);
        data.append('economicCodeCompany', economicCodeCompany);
        data.append('json', JSON.stringify(dataAdd));

        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://khpc.ir/api-supplier/api/sendRequestStepOne',
            data: data
        };

        axios.request(config)
            .then((response) => {
                if (response.data.error) {
                    alert(response.data.message);
                } else {
                    props.setRequestId(response.data.id)
                    props.setType(type);
                    props.setNationalCode(nationalCode);
                    props.setIdInternationalCode(idInternationalCode);
                    props.setEconomicCodeCompany(economicCodeCompany);
                    props.setData(dataAdd);
                    props.changeStep("2");
                }
                setSubmit(false);
            })
            .catch((error) => {
                alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                setSubmit(false);
            });

    }

    const handleSetDate = (date) => {
        if (!date) return;
        var newDate = new Date(date);
        var returnDate = `${newDate.getFullYear()}/${(newDate.getMonth() + 1) < 10 ? `0` + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getDate() < 10 ? `0` + newDate.getDate() : newDate.getDate()}`;
        setEstablishmentStore(returnDate)
    }

    const handleSetDateReg = (date) => {
        if (!date) return;
        var newDate = new Date(date);
        var returnDate = `${newDate.getFullYear()}/${(newDate.getMonth() + 1) < 10 ? `0` + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getDate() < 10 ? `0` + newDate.getDate() : newDate.getDate()}`;
        setRegisterDateCompany(returnDate)
    }

    const defaultDate = () => {
        var newDate = Math.round(+new Date() / 1000);
        console.log(newDate);
        return newDate;
        // var returnDate = `${newDate.getFullYear()}/${(newDate.getMonth() + 1) < 10 ? `0` + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getDate() < 10 ? `0` + newDate.getDate() : newDate.getDate()}`;
        // return returnDate;
    }

    if (firstData) {
        return (
            <>
                <Container className="mt-2" >
                    <Row>
                        <Col xs="12">
                            در حال بارگزاری
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }


    return (
        <Container className="mt-2" >
            <Row>
                <Col xs="12">
                    <label className="mb-2">شخصیت <sup style={{ color: 'red' }}>*</sup></label>
                    <Form.Select isInvalid={false} style={{ width: '50%' }} onChange={(e) => setType(e.target.value)} value={type} aria-label="Default select example">
                        <option selected={type == "1"} value="1">حقیقی</option>
                        <option selected={type == "2"} value="2">حقوقی</option>
                    </Form.Select>
                </Col>
                <Col xs="12" className="mt-4">
                    <label className="mb-2">نوع فعالیت <sup style={{ color: 'red' }}>*</sup></label>
                    <Form.Check
                        type="switch"
                        id="custom-switch-one"
                        label="سازنده"
                        checked={builder}
                        onChange={(e) => setBuilder(e.target.checked)}
                    />
                    <Form.Check
                        type="switch"
                        id="custom-switch-two"
                        label="بازرگانی"
                        checked={commerce}
                        onChange={(e) => setCommerce(e.target.checked)}
                    />
                    <Form.Check
                        type="switch"
                        id="custom-switch-three"
                        label="خدماتی"
                        checked={service}
                        onChange={(e) => setService(e.target.checked)}
                    />
                    <Form.Check
                        type="switch"
                        id="custom-switch-four"
                        label="پیمانکار"
                        checked={contractor}
                        onChange={(e) => { setContractor(e.target.checked); props.handleContractor(e.target.checked) }}
                    />
                </Col>

                {
                    builder ||
                        commerce ||
                        service ||
                        contractor ?


                        <>
                            {type == 2 && (
                                <>
                                    <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                                        <label className="text-g fw-bold">نوع شرکت <sup style={{ color: 'red' }}>*</sup></label>
                                    </Col>
                                    <Col xs={12} className="mt-4">
                                        <Form.Check
                                            inline
                                            label="سهامی خاص"
                                            id="ij"
                                            name="typeCompany"
                                            value={1}
                                            checked={typeCompany == 1}
                                            onChange={(e) => setTypeCompany(e.target.value)}
                                            type={'radio'}
                                        />
                                        <Form.Check
                                            inline
                                            label="سهامی عام"
                                            id="thgf2"
                                            name="typeCompany"
                                            value={2}
                                            checked={typeCompany == 2}
                                            onChange={(e) => setTypeCompany(e.target.value)}
                                            type={'radio'}
                                        />
                                        <Form.Check
                                            inline
                                            label="مسئولیت محدود"
                                            name="typeCompany"
                                            id="tkjl3"
                                            value={3}
                                            checked={typeCompany == 3}
                                            onChange={(e) => setTypeCompany(e.target.value)}
                                            type={'radio'}
                                        />
                                        <Form.Check
                                            inline
                                            label="تعاونی"
                                            name="typeCompany"
                                            id="kjh8t4"
                                            value={4}
                                            checked={typeCompany == 4}
                                            onChange={(e) => setTypeCompany(e.target.value)}
                                            type={'radio'}
                                        />
                                        <Form.Check
                                            inline
                                            label="سایر"
                                            name="typeCompany"
                                            id="kkj9"
                                            value={5}
                                            checked={typeCompany == 5}
                                            onChange={(e) => setTypeCompany(e.target.value)}
                                            type={'radio'}
                                        />
                                        {
                                            typeCompany == 5 &&
                                            <Form.Group controlId="otherTypeCompany">
                                                <Form.Control isInvalid={submit && typeCompany == 5 && otherTypeCompany == ''} value={otherTypeCompany} onChange={(e) => setOtherTypeCompany(e.target.value)} type="text" placeholder="نوع شرکت را وارد کنید" />
                                            </Form.Group>
                                        }
                                    </Col>
                                </>
                            )
                            }

                            <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                                <label className="text-g fw-bold">مشخصات</label>
                            </Col>

                            {
                                type == 1 ?
                                    <>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="store">
                                                <Form.Label>نام فروشگاه <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && store == ''} value={store} onChange={(e) => setStore(e.target.value)} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="oldstore">
                                                <Form.Label>نام قدیم فروشگاه</Form.Label>
                                                <Form.Control value={oldStore} onChange={(e) => setOldStore(e.target.value)} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="businessLicense">
                                                <Form.Label>شماره پروانه کسب <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && businessLicense == ''} value={businessLicense} onChange={(e) => {
                                                    if (/^[0-9]+$/.test(e.target.value) ||
                                                        e.nativeEvent.inputType == "deleteContentBackward" ||
                                                        e.nativeEvent.inputType == "deleteContentForward")
                                                        setBusinessLicense(e.target.value)
                                                }} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="establishmentStore">
                                                <Form.Label>تاریخ تاسیس فروشگاه <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <div>
                                                    <DatePicker defaultValue={establishmentStore ? establishmentStore : undefined} inputClass={`datepicker ${submit && establishmentStore == '' && 'invalid-date'}`} direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDate(e.value)} />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="nationalCode">
                                                <Form.Label>کد ملی <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && nationalCode == ''} value={nationalCode} onChange={(e) => {
                                                    if (/^[0-9]+$/.test(e.target.value) ||
                                                        e.nativeEvent.inputType == "deleteContentBackward" ||
                                                        e.nativeEvent.inputType == "deleteContentForward")
                                                        setNationalCode(e.target.value)
                                                }} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="economicCode">
                                                <Form.Label>کد اقتصادی </Form.Label>
                                                <Form.Control value={economicCode} onChange={(e) => {
                                                    if (/^[0-9]+$/.test(e.target.value) ||
                                                        e.nativeEvent.inputType == "deleteContentBackward" ||
                                                        e.nativeEvent.inputType == "deleteContentForward")
                                                        setEconomicCode(e.target.value)
                                                }} type="text" />
                                            </Form.Group>
                                        </Col>
                                    </>
                                    :
                                    <>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="companyName">
                                                <Form.Label>نام شرکت <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && companyName == ''} value={companyName} onChange={(e) => setCompanyName(e.target.value)} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="oldCompanyName">
                                                <Form.Label>نام قدیم شرکت</Form.Label>
                                                <Form.Control value={oldCompanyName} onChange={(e) => setOldCompanyName(e.target.value)} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="registerCodeCompany">
                                                <Form.Label>شماره ثبت شرکت <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && registerCodeCompany == ''} value={registerCodeCompany} onChange={(e) => {
                                                    if (/^[0-9]+$/.test(e.target.value) ||
                                                        e.nativeEvent.inputType == "deleteContentBackward" ||
                                                        e.nativeEvent.inputType == "deleteContentForward")
                                                        setRegisterCodeCompany(e.target.value)
                                                }} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="registerDateCompany">
                                                <Form.Label>تاریخ تاسیس شرکت <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <div>
                                                    <DatePicker defaultValue={registerDateCompany ? registerDateCompany : undefined} inputClass={`datepicker ${submit && registerDateCompany == '' && 'invalid-date'}`} direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDateReg(e.value)} />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="idInternationalCode">
                                                <Form.Label>کد شناسه ملی <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && idInternationalCode == ''} value={idInternationalCode} onChange={(e) => {
                                                    if (/^[0-9]+$/.test(e.target.value) ||
                                                        e.nativeEvent.inputType == "deleteContentBackward" ||
                                                        e.nativeEvent.inputType == "deleteContentForward")
                                                        setIdInternationalCode(e.target.value)
                                                }} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="economicCodeCompany">
                                                <Form.Label>کد اقتصادی  <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && economicCodeCompany == ''} value={economicCodeCompany} onChange={(e) => {
                                                    if (/^[0-9]+$/.test(e.target.value) ||
                                                        e.nativeEvent.inputType == "deleteContentBackward" ||
                                                        e.nativeEvent.inputType == "deleteContentForward")
                                                        setEconomicCodeCompany(e.target.value)
                                                }} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="companyCapital">
                                                <Form.Label>سرمایه شرکت (ریال) <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && companyCapital == ''} value={companyCapital} onChange={(e) => {
                                                    if (/^[0-9]+$/.test(e.target.value) ||
                                                        e.nativeEvent.inputType == "deleteContentBackward" ||
                                                        e.nativeEvent.inputType == "deleteContentForward")
                                                        setCompanyCapital(e.target.value)
                                                }} type="text" />
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} className="mt-4" md={6}>
                                            <Form.Group controlId="managerName">
                                                <Form.Label>نام مدیرعامل <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                                <Form.Control isInvalid={submit && managerName == ''} value={managerName} onChange={(e) => setManagerName(e.target.value)} type="text" />
                                            </Form.Group>
                                        </Col>
                                    </>
                            }


                            <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                                <label className="text-g fw-bold">آدرس</label>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <label htmlFor="province" className="mb-2">استان <sup style={{ color: 'red' }}>*</sup></label>
                                <Form.Select defaultValue={province ? province : null} value={province ? province : null} isInvalid={submit && province == ''} id="province" onChange={(e) => setProvince(e.target.value)} aria-label="Default select example">
                                    <option value={''}>انتخاب کنید</option>
                                    {
                                        Province.map(item => {
                                            return <option key={item.province_id} value={item.province_id}>{item.province_name}</option>
                                        })
                                    }
                                </Form.Select>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <label htmlFor="city" className="mb-2">شهر <sup style={{ color: 'red' }}>*</sup></label>
                                <Form.Select defaultValue={city ? city : null} value={city ? city : null} isInvalid={submit && city == ''} id="city" onChange={(e) => setCity(e.target.value)} aria-label="Default select example">
                                    <option value={''}>انتخاب کنید</option>
                                    {
                                        City.filter(item => item.province_id == province).map(item => {
                                            return <option key={item.city_id} value={item.city_id}>{item.city_name}</option>
                                        })
                                    }
                                </Form.Select>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="postalcode">
                                    <Form.Label>کد پستی <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && postalcode == ''} value={postalcode} onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setPostalCode(e.target.value)
                                    }} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="postbox">
                                    <Form.Label>صندوق پستی</Form.Label>
                                    <Form.Control value={postBox} onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setPostBox(e.target.value)
                                    }} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4">
                                <Form.Group controlId="address">
                                    <Form.Label>نشانی <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && address == ''} value={address} onChange={(e) => setAddress(e.target.value)} as="textarea" rows={3} />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="phone">
                                    <Form.Label>تلفن <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setPhone(e.target.value)
                                    }} style={{ textAlign: 'left', direction: 'ltr' }} isInvalid={submit && phone == ''} value={phone} type="tel" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="phonetwo">
                                    <Form.Label>تلفن</Form.Label>
                                    <Form.Control onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setPhoneTwo(e.target.value)
                                    }} style={{ textAlign: 'left', direction: 'ltr' }} value={phoneTwo} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="phonethree">
                                    <Form.Label>تلفن</Form.Label>
                                    <Form.Control onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setphoneThree(e.target.value)
                                    }} style={{ textAlign: 'left', direction: 'ltr' }} value={phoneThree} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="cellphone">
                                    <Form.Label>همراه <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setCellPhone(e.target.value)
                                    }} style={{ textAlign: 'left', direction: 'ltr' }} isInvalid={submit && cellPhone == ''} value={cellPhone} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="fax">
                                    <Form.Label>نمابر</Form.Label>
                                    <Form.Control onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setFax(e.target.value)
                                    }} style={{ textAlign: 'left', direction: 'ltr' }} value={fax} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="email">
                                    <Form.Label>پست الکترونیک <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && email == ''} value={email} onChange={(e) => setEmail(e.target.value)} type="email" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="website">
                                    <Form.Label>آدرس وب سایت</Form.Label>
                                    <Form.Control value={website} onChange={(e) => setWebsite(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="citycode">
                                    <Form.Label>کد شهر <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setCityCode(e.target.value)
                                    }} isInvalid={submit && cityCode == ''} value={cityCode} type="tel" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                                <label className="text-g fw-bold">مشخصات بانکی</label>
                            </Col>
                            <Col xs={12} className="mt-2">
                                <label className="text-g fw-bold">حساب بانکی اول</label>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <label htmlFor="bank" className="mb-2">بانک <sup style={{ color: 'red' }}>*</sup></label>
                                <Form.Select isInvalid={submit && bank == ''} id="bank" value={bank} onChange={(e) => setBank(e.target.value)} aria-label="Default select example">
                                    <option value={''}>انتخاب کنید</option>
                                    {
                                        Banks.map(item => {
                                            return <option key={item.id} value={item.id}>{item.name}</option>
                                        })
                                    }
                                </Form.Select>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="branch">
                                    <Form.Label>شعبه <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && branch == ''} value={branch} onChange={(e) => setBranch(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="shaba">
                                    <Form.Label>شبا <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && shaba == ''} value={shaba} onChange={(e) => setShaba(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="accountNumber">
                                    <Form.Label>شماره حساب <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && accountNumber == ''} value={accountNumber} onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setAccountNumber(e.target.value)
                                    }} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="ownerName">
                                    <Form.Label>بنام <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && ownerName == ''} value={ownerName} onChange={(e) => setOwnerName(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4">
                                <label className="text-g fw-bold">حساب بانکی دوم</label>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <label htmlFor="banktwo" className="mb-2">بانک</label>
                                <Form.Select id="banktwo" value={bankTwo} onChange={(e) => setBankTwo(e.target.value)} isInvalid={false} aria-label="Default select example">
                                    <option value={''}>انتخاب کنید</option>
                                    {
                                        Banks.map(item => {
                                            return <option key={item.id} value={item.id}>{item.name}</option>
                                        })
                                    }
                                </Form.Select>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="branchTwo">
                                    <Form.Label>شعبه</Form.Label>
                                    <Form.Control value={branchTwo} onChange={(e) => setBranchTwo(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="shabaTwo">
                                    <Form.Label>شبا</Form.Label>
                                    <Form.Control value={shabaTwo} onChange={(e) => setShabaTwo(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="accountNumberTwo">
                                    <Form.Label>شماره حساب</Form.Label>
                                    <Form.Control value={accountNumberTwo} onChange={(e) => {
                                        if (/^[0-9]+$/.test(e.target.value) ||
                                            e.nativeEvent.inputType == "deleteContentBackward" ||
                                            e.nativeEvent.inputType == "deleteContentForward")
                                            setAccountNumberTwo(e.target.value)
                                    }} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="ownerNameTwo">
                                    <Form.Label>بنام</Form.Label>
                                    <Form.Control value={ownerNameTwo} onChange={(e) => setOwnerNameTwo(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>

                            <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                                <label className="text-g fw-bold">نوع مالکیت <sup style={{ color: 'red' }}>*</sup></label>
                            </Col>
                            <Col xs={12} className="mt-4">
                                <Form.Check
                                    inline
                                    label="دولتی"
                                    id="t1"
                                    name="group1"
                                    value={1}
                                    checked={ownership == 1}
                                    onChange={(e) => setOwnership(e.target.value)}
                                    type={'radio'}
                                />
                                <Form.Check
                                    inline
                                    label="خصوصی"
                                    id="t2"
                                    name="group1"
                                    value={2}
                                    checked={ownership == 2}
                                    onChange={(e) => setOwnership(e.target.value)}
                                    type={'radio'}
                                />
                                <Form.Check
                                    inline
                                    label="عمومی"
                                    name="group1"
                                    id="t3"
                                    value={3}
                                    checked={ownership == 3}
                                    onChange={(e) => setOwnership(e.target.value)}
                                    type={'radio'}
                                />
                                <Form.Check
                                    inline
                                    label="تحت پوشش"
                                    name="group1"
                                    id="t4"
                                    value={4}
                                    checked={ownership == 4}
                                    onChange={(e) => setOwnership(e.target.value)}
                                    type={'radio'}
                                />
                                <Form.Check
                                    inline
                                    label="تعاونی"
                                    name="group1"
                                    id="t5"
                                    value={5}
                                    checked={ownership == 5}
                                    onChange={(e) => setOwnership(e.target.value)}
                                    type={'radio'}
                                />
                                <Form.Check
                                    inline
                                    label="سایر"
                                    name="group1"
                                    id="t6"
                                    value={6}
                                    checked={ownership == 6}
                                    onChange={(e) => setOwnership(e.target.value)}
                                    type={'radio'}
                                />
                                {
                                    ownership == 6 &&
                                    <Form.Group controlId="otherOwnerShip">
                                        <Form.Control isInvalid={submit && ownership == 6 && otherOwnerShip == ''} value={otherOwnerShip} onChange={(e) => setOtherOwnerShip(e.target.value)} type="text" placeholder="مالکیت را وارد کنید" />
                                    </Form.Group>
                                }
                            </Col>
                            <Col xs={12} className="mt-4" md={6}>
                                <Form.Group controlId="formCompletion">
                                    <Form.Label>تکمیل کننده فرم <sup style={{ color: 'red' }}>*</sup></Form.Label>
                                    <Form.Control isInvalid={submit && formCompletion == ''} value={formCompletion} onChange={(e) => setFormCompletion(e.target.value)} type="text" />
                                </Form.Group>
                            </Col>
                            <Col xs={12} className="mt-4 text-center" >
                                <div className="d-grid gap-2">
                                    <Button variant="success" onClick={() => changeStep()}>
                                        مرحله بعد
                                    </Button>
                                </div>
                            </Col>
                        </>
                        : null
                }

            </Row >
        </Container >
    )
}